import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import i18n from '@/common/i18n/i18n.js';
import router from '@/router.js';

import { capitalizeFirstLetter } from '@/utils';

export class ErrorService {

  static onError(error, message, title) {

    toastr.options = {
      closeButton: true,
      debug: false,
      newestOnTop: true,
      progressBar: false,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      onclick: null,
      showDuration: '300',
      hideDuration: '1000',
      timeOut: '5000',
      extendedTimeOut: '5000',
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut'
    };

    if (error) {
      const response = error.response;
      // Handle errors code
      if (response && response.status === 403) {
        router.push({ name: '403Page' });
      } else if (response && (response.status >= 400 && response.status < 405)) {
        const messages = [];
        if (message) {
          messages.push(message);
        } else {
          const errorObj = response.data && typeof response.data === 'object' ? response.data : {};
          // eslint-disable-next-line no-inner-declarations
          function recurse(obj) {
            for (const [key, value] of Object.entries(obj)) {
              if (typeof value === 'string') {
                messages.push(`${capitalizeFirstLetter(key)} : ${value}`);
              } else if (Array.isArray(value) && value.length === 1) {
                messages.push(`${capitalizeFirstLetter(key)} : ${value[0]}`);
              } else if (typeof value === 'object') {
                recurse(value);
              } else {
                return;
              }
            }
          }
          recurse(errorObj);

        }
        if (messages.length > 1) {
          toastr.error(`<ul>${messages.join('\n')}</ul>`, 'Erreur');
        } else {
          toastr.error(messages && messages.length ? `${messages[0]}` : '', `${ title || 'Erreur'}`);
        }
        return false;
      } else if (response && response.status === 500) {
        toastr.error('Erreur critique', response.status);
        return false;
      }
    } else if (!error && message) {
      toastr.error(message);
      return false;
    } else {
      toastr.error(i18n.messages[i18n].messages.error.default);
      return false;
    }
  }

  static onSuccess(response, message = i18n.messages[i18n.locale].messages.success.default) {

    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: true,
      progressBar: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      onclick: null,
      showDuration: '300',
      hideDuration: '1000',
      timeOut: '5000',
      extendedTimeOut: '5000',
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut'
    };

    if (response) {
      toastr.success(`${message}`);
      return false;
    }
  }
}
